<header class="position-relative">
  <div class="page-wide">
    <nav class="navbar navbar-expand-lg navbar-light d-flex d-md-none">
      <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center">
          <div class="logo-wrapper">
            <div class="logo" routerLink="/"><img src="assets/svg/fhi_logo.svg" height="75" alt="FairBridgeInns Logo" />
            </div>
          </div>
          <div class="d-flex flex-column flex-lg-row justify-content-between align-items-center d-flex d-md-none">
            <div class="w-100 w-lg-auto">
              <div class="d-flex align-items-center w-100 w-lg-auto justify-content-between">
                <div class="menu-wrapper">
                  <div class="main-menu d-none d-sm-block">
                    <ul>
                      <li class="destination-item mx-3">All Destinations <svg xmlns="http://www.w3.org/2000/svg" width="16"
                          height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                        </svg>

                        <div class="destination-dropdown">
                          <div class="destinations-by-type d-flex">
                            <div class="destinations-by-type-sidebar">
                              <span class="sidebar-caption">All Destinations</span>
                              <ul>
                                <li [ngClass]="{'active': destinationCurrentTab === DestinationEnum.State}"
                                  (click)="onDestinationType(DestinationEnum.State)"><span>By State</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-chevron-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                  </svg>
                                </li>
                                <li [ngClass]="{'active': destinationCurrentTab === DestinationEnum.Brand}"
                                  (click)="onDestinationType(DestinationEnum.Brand)"><span>By Brand</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-chevron-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                  </svg>
                                </li>
                              </ul>
                            </div>
                            <div class="destinations-by-type-container d-flex justify-content-between">
                              <div class="destinations-by-type-container-left flex-fill">
                                <div class="destinations-by-type-container-label">
                                  <ng-template [ngIf]="!currentStateTitleProperties">All
                                    {{destinationCurrentTab}}s</ng-template>
                                  <span class="back-label" *ngIf="currentStateTitleProperties" (click)="onBack()"><svg
                                      xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                      class="bi bi-chevron-left" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd"
                                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                    </svg> Back</span>
                                </div>

                                <!-- States Container -->
                                <div *ngIf="destinationCurrentTab === DestinationEnum.State"
                                  class="destination-wrapper d-flex">
                                  <div class="states-wrapper" *ngIf="!currentStateTitleProperties">
                                    <div class="state" *ngFor="let propertyGroup of propertiesByType">
                                      <h3 (click)="onStateTitle(propertyGroup)">{{propertyGroup?.title}}</h3>
                                    </div>
                                  </div>

                                  <div class="currentProperties" *ngIf="currentStateTitleProperties">
                                    <h3>{{currentStateTitleProperties?.title}}</h3>
                                    <div class="property-hover-wrapper">
                                      <div class="property d-flex">
                                        <div class="w-200"
                                          *ngFor="let property of currentStateTitleProperties?.properties; let rowIndex = index">
                                          <a (mouseenter)="onPropertyTitleHover(property)"
                                            [routerLink]="['hotel', property?.slug]">{{property?.city}}</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!-- Brands container -->
                                <div *ngIf="destinationCurrentTab === DestinationEnum.Brand" class="destination-wrapper">
                                  <div class="states-wrapper d-flex" *ngIf="!currentStateTitleProperties" fxLayoutGap="40px">
                                    <div class="property-group by-brand" class="w-200 p-4 text-center"
                                      *ngFor="let propertyGroup of propertiesByType">
                                      <img (click)="onStateTitle(propertyGroup)" [src]="propertyGroup?.image" width="190" />
                                      <hr />
                                      <h3 class="text-center" (click)="onStateTitle(propertyGroup)">{{propertyGroup?.title}}
                                      </h3>
                                    </div>
                                  </div>

                                  <div class="currentProperties" *ngIf="currentStateTitleProperties">
                                    <h3>{{currentStateTitleProperties?.title}}</h3>
                                    <div class="property-hover-wrapper">
                                      <div class="property" fxLayout="row" fxLayoutAlign="start start">
                                        <div class="w-200"
                                          *ngFor="let property of currentStateTitleProperties?.properties; let rowIndex = index">
                                          <a (mouseenter)="onPropertyTitleHover(property)"
                                            [routerLink]="['hotel', property?.slug]">{{property?.city}}</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="destinations-by-type-container-right" *ngIf="currentStateTitleProperties">
                                <div class="property-hovered">
                                  <a *ngIf="propertyHovered" [routerLink]="['hotel', propertyHovered?.slug]">
                                    <img *ngIf="getHoveredPropertyImg()" [src]="assets_base + getHoveredPropertyImg()" />
                                    <h2>{{propertyHovered?.city}}, {{propertyHovered?.state}}</h2>
                                    <div class="hotel-header-details d-flex">
                                      <div class="phone">
                                        <span>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                            class="bi bi-telephone" viewBox="0 0 16 16">
                                            <path
                                              d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                          </svg>
                                          <ng-template
                                            [ngIf]="propertyHovered?.phoneAreacode">({{propertyHovered?.phoneAreacode}})
                                          </ng-template>
                                          {{propertyHovered?.phoneNumber}}
                                        </span>
                                      </div>
                                      <div class="dot-seperator d-none d-sm-block px-2">·</div>
                                      <div class="address">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                          class="bi bi-geo-alt" viewBox="0 0 16 16">
                                          <path
                                            d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                          <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg>
                                        {{propertyHovered?.street}}, {{propertyHovered?.city}},
                                        {{propertyHovered?.state}} {{propertyHovered?.postalCode}}
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li><a routerLink="development">Brand Development</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <ul class="navbar-nav">
            <li class="nav-item" >
              <a class="nav-link" [routerLink]='"."' [fragment]="'brands'">Our Brands</a></li>
            <li class="nav-item"><a class="nav-link" routerLink="meeting-events">Meetings & Events</a></li>
            <li class="nav-item"><a class="nav-link" routerLink="faqs">FAQs</a></li>
            @if (isLoggedIn()) {
              <li class="nav-item"><a class="nav-link" routerLink="./loyalty">My Account</a></li>
              <li class="nav-item"><a class="nav-link" (click)="logout()">Logout</a></li>
            }
            @else {
              <li class="nav-item">
                <a class="nav-link" routerLink="./login">SIGN IN</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="./register">REGISTER</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </nav>

    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-center d-none d-md-flex">
      <div class="w-100 w-lg-auto">
        <div class="d-flex align-items-center w-100 w-lg-auto justify-content-between">
          <div class="logo-wrapper">
            <div class="logo" routerLink="/"><img src="assets/svg/fhi_logo.svg" height="75" alt="FairBridgeInns Logo" />
            </div>
          </div>
          <div class="menu-wrapper">
            <div class="main-menu d-none d-sm-block">
              <ul>
                <li [routerLink]='"."' [fragment]="'brands'">Our Brands</li>
                <li class="destination-item">All Destinations <svg xmlns="http://www.w3.org/2000/svg" width="16"
                    height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                  </svg>

                  <div class="destination-dropdown">
                    <div class="destinations-by-type d-flex">
                      <div class="destinations-by-type-sidebar">
                        <span class="sidebar-caption">All Destinations</span>
                        <ul>
                          <li [ngClass]="{'active': destinationCurrentTab === DestinationEnum.State}"
                            (click)="onDestinationType(DestinationEnum.State)"><span>By State</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-chevron-right" viewBox="0 0 16 16">
                              <path fill-rule="evenodd"
                                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                            </svg>
                          </li>
                          <li [ngClass]="{'active': destinationCurrentTab === DestinationEnum.Brand}"
                            (click)="onDestinationType(DestinationEnum.Brand)"><span>By Brand</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-chevron-right" viewBox="0 0 16 16">
                              <path fill-rule="evenodd"
                                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                            </svg>
                          </li>
                        </ul>
                      </div>
                      <div class="destinations-by-type-container d-flex justify-content-between">
                        <div class="destinations-by-type-container-left flex-fill">
                          <div class="destinations-by-type-container-label">
                            <ng-template [ngIf]="!currentStateTitleProperties">All
                              {{destinationCurrentTab}}s</ng-template>
                            <span class="back-label" *ngIf="currentStateTitleProperties" (click)="onBack()"><svg
                                xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-chevron-left" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                              </svg> Back</span>
                          </div>

                          <!-- States Container -->
                          <div *ngIf="destinationCurrentTab === DestinationEnum.State"
                            class="destination-wrapper d-flex">
                            <div class="states-wrapper" *ngIf="!currentStateTitleProperties">
                              <div class="state" *ngFor="let propertyGroup of propertiesByType">
                                <h3 (click)="onStateTitle(propertyGroup)">{{propertyGroup?.title}}</h3>
                              </div>
                            </div>

                            <div class="currentProperties" *ngIf="currentStateTitleProperties">
                              <h3>{{currentStateTitleProperties?.title}}</h3>
                              <div class="property-hover-wrapper">
                                <div class="property d-flex">
                                  <div class="w-200"
                                    *ngFor="let property of currentStateTitleProperties?.properties; let rowIndex = index">
                                    <a (mouseenter)="onPropertyTitleHover(property)"
                                      [routerLink]="['hotel', property?.slug]">{{property?.city}}</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Brands container -->
                          <div *ngIf="destinationCurrentTab === DestinationEnum.Brand" class="destination-wrapper">
                            <div class="states-wrapper d-flex" *ngIf="!currentStateTitleProperties" fxLayoutGap="40px">
                              <div class="property-group by-brand" class="w-200 p-4 text-center"
                                *ngFor="let propertyGroup of propertiesByType">
                                <img (click)="onStateTitle(propertyGroup)" [src]="propertyGroup?.image" width="190" />
                                <hr />
                                <h3 class="text-center" (click)="onStateTitle(propertyGroup)">{{propertyGroup?.title}}
                                </h3>
                              </div>
                            </div>

                            <div class="currentProperties" *ngIf="currentStateTitleProperties">
                              <h3>{{currentStateTitleProperties?.title}}</h3>
                              <div class="property-hover-wrapper">
                                <div class="property" fxLayout="row" fxLayoutAlign="start start">
                                  <div class="w-200"
                                    *ngFor="let property of currentStateTitleProperties?.properties; let rowIndex = index">
                                    <a (mouseenter)="onPropertyTitleHover(property)"
                                      [routerLink]="['hotel', property?.slug]">{{property?.city}}</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="destinations-by-type-container-right" *ngIf="currentStateTitleProperties">
                          <div class="property-hovered">
                            <a *ngIf="propertyHovered" [routerLink]="['hotel', propertyHovered?.slug]">
                              <img *ngIf="getHoveredPropertyImg()" [src]="assets_base + getHoveredPropertyImg()" />
                              <h2>{{propertyHovered?.city}}, {{propertyHovered?.state}}</h2>
                              <div class="hotel-header-details d-flex">
                                <div class="phone">
                                  <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                      class="bi bi-telephone" viewBox="0 0 16 16">
                                      <path
                                        d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                    </svg>
                                    <ng-template
                                      [ngIf]="propertyHovered?.phoneAreacode">({{propertyHovered?.phoneAreacode}})
                                    </ng-template>
                                    {{propertyHovered?.phoneNumber}}
                                  </span>
                                </div>
                                <div class="dot-seperator d-none d-sm-block px-2">·</div>
                                <div class="address">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-geo-alt" viewBox="0 0 16 16">
                                    <path
                                      d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                  </svg>
                                  {{propertyHovered?.street}}, {{propertyHovered?.city}},
                                  {{propertyHovered?.state}} {{propertyHovered?.postalCode}}
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li><a routerLink="meeting-events">Meetings & Events</a></li>
                <li><a routerLink="faqs">FAQs</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="right-actions d-flex gap-2 gap-md-4 w-100 w-lg-auto justify-content-end">
        @if (isHome) {
          <div class="ukraine mt-3 d-none d-lg-block">
            <a href="https://www.patreon.com/HotelsSupportUkraine" target="_blank" class="text-black text-decoration-none">
              <div class="d-flex  gap-2">
                <div class="title text-uppercase">Proudly<br /> Support<br /> Ukraine</div>
                <img src="/assets/svg/ukraine_support_flag.svg" height="50">
              </div>
            </a>
          </div>
        }

        <div class="d-flex flex-row flex-lg-column justify-content-between align-items-center">
          <div class="user-links">
            @if (isLoggedIn()) {
            <div class="login-register">
              <div class="btn-group btn-link">
                <a routerLink="./loyalty"><button class="btn">My Account</button></a>
                <button class="btn" (click)="logout()">Logout</button>
              </div>
            </div>
            } @else {
            <div class="login-register">
              <div class="btn-group btn-link">
                <a routerLink="./login"><button class="btn">SIGN IN</button></a>
                <a routerLink="./register"><button class="btn">REGISTER</button></a>
              </div>
            </div>
            }
          </div>
          <div class="menu-search d-none d-md-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search"
              viewBox="0 0 16 16">
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>

            <ng-select class="" [items]="properties" placeholder="Hotel, city or state" bindLabel="name"
              bindValue="webUrl" groupBy="state" [searchFn]="propertySearchFn" [loading]="propertyLoading"
              [(ngModel)]="selectedProperty" (change)="onPropertyChange($event)">
              <ng-template ng-optgroup-tmp let-item="item">
                {{item.state || 'Others'}}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{item.name}} <br />
                <small><strong>{{item.city}}</strong></small>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
